import axios from "axios";
import qs from "qs";
import { cookie, debounce, getUrlParams } from "@js/utils";
import store from "@/store";
import router from "@/router";

const prefixPath = "/", // 公用前缀路径
  baseURL = process.env.VUE_APP_APIURL; // 请求地址
let isTest = getUrlParams("test", null, 0) || getUrlParams("test");
// let authorization =
//   isTest && process.env.VUE_APP_MODE !== "prod"
//     ? "eyJsb2dpblRzIjoiMTY0NTYwODgyNSIsIm5pY2tuYW1lIjoidGVzdDkiLCJzaWduIjoiYTFlNzJjNzEyNDY4MjU1ZjZkYTg3ODJhOTRjMTUwZTEiLCJ0b2tlbiI6InRlc3Q5IiwidXNlcm5hbWUiOiJ0ZXN0OSIsInV1aWQiOiIzNTQ2MTc4NTlAcXEuY29tIn0="
//     : "";
let authorization =
  isTest && process.env.VUE_APP_MODE !== "prod"
    ? "eyJsb2dpblRzIjoiMTY0MTM3NTcwMCIsIm5pY2tuYW1lIjoidGVzdCIsInNpZ24iOiI3M2IyNWE4MjQwNmZlODYxMjEyMTY5MzdjYmY5NTk0MiIsInRva2VuIjoidGVzdCIsInVzZXJuYW1lIjoidGVzdCIsInV1aWQiOiJ0ZXN0MDAxIn0="
    : "";

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;

// 监听浏览器联网状态
if (navigator.connection) {
  navigator.connection.onchange = debounce(function () {
    if (!navigator.onLine) {
      $toast("no network");
    }
  });
}

// require拦截
axios.interceptors.request.use((config) => {
  if (isTest && process.env.VUE_APP_MODE !== "prod") {
    config.headers.Authorization = "Bearer " + authorization;
  }
  config.baseURL = `${baseURL}/${prefixPath}`;
  config.url = config.url;
  return config;
});

// response拦截
axios.interceptors.response.use(
  (response) => {
    let {
      data: { msg, status },
    } = response;
    if (status != 200) {
      if (status == 401) {
        $toast(msg, 24 * 360 * 1000);
      } else {
        $toast(msg || "系统错误");
      }
    } else {
      if (
        response.config.url.indexOf("task-list") == -1 &&
        response.config.url.indexOf("user/info") == -1 &&
        router.history.current.path == "/"
      ) {
        updateTask();
      }
    }
    return response;
  },
  (err) => {
    return Promise.resolve({
      data: {
        status: 500,
        msg: navigator.onLine ? "sorry! timeout" : "no network",
      },
    });
    // $toast("sorry! timeout");
  }
);

/**
 * post请求
 * @param {String} url 请求路径
 * @param {Object} data 请求参数
 * @param {Boolean} fetchCode 是否获取接口返回的code，默认为false时 返回接口响应的data对象，为true时 返回接口响应的所有内容
 */
function post(url, data, fetchCode = false, config = {}) {
  return comajax({ url, data, config }).then((res) => {
    res = res.data || false;
    return responseData(res, fetchCode);
  });
}

/**
 * get请求
 * @param {String} url 请求路径
 * @param {Object} data 请求参数
 * @param {Boolean} fetchCode 是否获取接口返回的code，默认为false时 返回接口响应的data对象，为true时 返回接口响应的所有内容
 */
function get(url, data, fetchCode = false) {
  return comajax({
    url: `${url}?${qs.stringify(data)}`,
  }).then((res) => {
    res = res.data || false;
    return responseData(res, fetchCode);
  });
}

/**
 * ajax请求
 * @param {Object} options 请求配置
 */
function comajax(options) {
  if ("data" in options) {
    let opt = Object.assign(
      {
        method: "post",
        url: options.url,
        data:
          options.config.type == "json"
            ? JSON.stringify(options.data)
            : qs.stringify(options.data),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
      options.config
    );
    return axios(opt);
  } else {
    return axios(options.url);
  }
}

// 实时获取任务状态
let updateTask = debounce(function () {
  store.dispatch("taskInfo/upDateTaskList");
}, 500);

/**
 * 响应处理
 * @param {any} data
 * @param {boolean} fetchCode
 */
function responseData(data, fetchCode) {
  if (fetchCode) {
    // if (data.status != 200) {
    //     // alert(data.msg)
    // }
    // return data || {
    //     status: null,
    //     data: false
    // }
    return data;
  } else {
    if (data.status == 200 || data.status == 1) {
      return data;
    } else {
      console.error(data.msg || "数据获取失败");
      return { data: false, ...data };
    }
  }
}

/**
 *
 * @param {string} url 请求路径
 * @param {object} params 请求参数
 * @param {string} type 请求方式
 * @param {boolean} fetchCode 是否获取完整响应数据(true返回data内的所有内容, false返回data.data的内容)
 */
function fetch({
  url,
  params = {},
  type = "get",
  fetchCode = true,
  config = {},
}) {
  if (type.toLowerCase() == "get") {
    return get(url, params, fetchCode);
  } else if (type.toLowerCase() == "post") {
    return post(url, params, fetchCode, config);
  }
}

// -------- demo --------
// export function postDemo({ params, fetchCode }) {
//     return fetch({
//         url: '/demo/post',
//         params,
//         type: 'post',
//         fetchCode
//     })
// }

// export function getDemo({ params, fetchCode }) {
//     return fetch({
//         url: '/demo/get',
//         params,
//         type: 'get',
//         fetchCode
//     })
// }

// -------- demo END--------
export default fetch;
